import CancelIcon from '@mui/icons-material/Cancel';
import { Alert, AlertTitle, Typography } from '@mui/material';
import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { useIntl } from 'react-intl';

import { theme } from '@verantos-dev/shared-styles';

export const ErrorMessage = ({
  validationError,
  creationError,
}: {
  validationError?: FetchBaseQueryError | SerializedError;
  creationError?: FetchBaseQueryError | SerializedError;
}) => {
  const intl = useIntl();
  return (
    <Alert
      severity="error"
      sx={{
        border: '1px',
        borderColor: theme.palette.error.main,
        borderStyle: 'solid',
        '& .MuiAlertTitle-root': { marginBottom: '0px' },
      }}
      icon={<CancelIcon sx={{ fontSize: '20px' }} />}
    >
      <AlertTitle fontSize={'16px'} fontWeight={500} color={theme.palette.text.primary}>
        {intl.formatMessage({ id: 'conceptGroup.error.title' })}
      </AlertTitle>
      <Typography fontSize={'16px'} fontWeight={400} color={theme.palette.text.secondary}>
        {validationError &&
          ('status' in validationError && validationError.status === 413
            ? intl.formatMessage({ id: 'conceptGroup.error.uploadTooLarge' })
            : intl.formatMessage({ id: 'conceptGroup.error.uploadError' }))}
        {creationError && intl.formatMessage({ id: 'conceptGroup.error.createError' })}
      </Typography>
    </Alert>
  );
};
